export default __webpack_public_path__ + "static/media/guide.4225e45d.webp";